import { render } from "./HealthCheckSnoozeModal.vue?vue&type=template&id=21a75fc2"
import script from "./HealthCheckSnoozeModal.vue?vue&type=script&lang=js"
export * from "./HealthCheckSnoozeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__